import React, { useEffect, useState } from 'react';
import { Box } from '@common-fe/common-fe';

import Title from '@/components/elements/ModuleTitle/ModuleTitle';

import EmployeeLoginHistoryList from './components/EmployeeLoginHistoryList';

interface Props {
  collapseSignal?: number;
  expandSignal?: number;
}

const EmployeeLoginHistory: React.FC<Props> = ({ collapseSignal, expandSignal }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (collapseSignal) {
      setIsExpanded(false);
    }
  }, [collapseSignal]);

  useEffect(() => {
    if (expandSignal) {
      setIsExpanded(true);
    }
  }, [expandSignal]);

  return (
    <>
      <Title testId="employee-login-history" title="Authentication History" isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
      {isExpanded && (
        <Box margin={{ top: 'spacing16' }}>
          <EmployeeLoginHistoryList />
        </Box>
      )}
    </>
  );
};

export default EmployeeLoginHistory;
